export function isEbayLander({ params }: { params?: URLSearchParams }) {
  return params?.get('utm_source')?.toLowerCase() === 'ebay';
}
